import {
  call,
  cancel,
  cancelled,
  fork,
  put,
  select,
  take,
} from 'redux-saga/effects'

import {
  TOKEN_STAKING_ACC,
  TOKEN_ACC,
  FIRST_EPOCH_DATE,
} from '../../app/constants'
import { setEpoch } from '../../features/staking/epochSlice'

// Query token staking details for current epoch
export function getEpochDetails(user, epoch) {
  return new Promise(async (resolve, reject) => {
    try {
      const { rows } = await user.userAccount.rpc.get_table_rows({
        json: true,
        code: TOKEN_STAKING_ACC,
        scope: TOKEN_STAKING_ACC,
        lower_bound: epoch,
        upper_bound: epoch,
        key_type: 'i64',
        index_position: 2,
        table: 'stakeepoch',
        limit: 15,
      })
      resolve(rows)
    } catch (error) {
      reject(error)
    }
  })
}

// Query Token staking details for logged in user
export function getUserEpochDetails(user) {
  return new Promise(async (resolve, reject) => {
    try {
      const { rows } = await user.userAccount.rpc.get_table_rows({
        json: true,
        code: TOKEN_STAKING_ACC,
        scope: TOKEN_STAKING_ACC,
        lower_bound: user.accountName,
        upper_bound: user.accountName,
        key_type: 'name',
        index_position: 2,
        table: 'stakeaccnts',
        limit: 1000,
      })
      resolve(rows)
    } catch (error) {
      reject(error)
    }
  })
}



// Query GLK circulating supply
export function getGlkCirculatingSupply(user) {
  return new Promise(async (resolve, reject) => {
    try {
      const { rows } = await user.userAccount.rpc.get_table_rows({
        json: true,
        code: TOKEN_ACC,
        scope: TOKEN_ACC,
        key_type: 'name',
        index_position: 1,
        table: 'circulating',
        limit: 1,
      })
      resolve(rows[0].circulating_supply.split(' ')[0])
    } catch (error) {
      reject(error)
    }
  })
}

export function* resolveEpochDetails() {
  // Calculate Todays Epoch
  const today = new Date()
  const utcToday = new Date(
    today.getUTCFullYear(),
    today.getUTCMonth(),
    today.getUTCDate(),
    today.getUTCHours(),
    today.getUTCMinutes(),
    today.getUTCSeconds(),
  )
  // Release date shouldn't change, check with backend team before launch
  const releaseDate = FIRST_EPOCH_DATE
  const Epoch = parseInt((utcToday - releaseDate) / (1000 * 60 * 60 * 6))

  // Calculate Todays Epoch for Testnet
  // const EpochTest = Math.floor(Epoch * 1)
  console.log('Today Epoch Number is:', Epoch)
  const { user } = yield select()

  // const nftTypes = stakeInfo.stakeSlots
  // console.log("DEBUG NFTTYPEID 2:", stakeInfo)


  try {
    const epochDetailsData = yield call(getEpochDetails, user, Epoch)
    const userEpochDetailsData = yield call(getUserEpochDetails, user)

    

    const glkCirculatingSupply = yield call(getGlkCirculatingSupply, user)

    console.log(
      epochDetailsData,
      userEpochDetailsData,
      glkCirculatingSupply,
    )
    yield put(
      setEpoch({
        type: 'FETCHING_SUCCESS',
        epochDetails: epochDetailsData,
        userEpochDetails: userEpochDetailsData,
        epoch: Epoch,
        glkCirculatingSupply,
      }),
    )
  } catch (error) {
    const errorMsg = error.toString()
    yield put(setEpoch({ type: 'FETCHING_ERROR', error: errorMsg }))
  } finally {
    if (yield cancelled()) {
      yield put(setEpoch({ type: 'FETCHING_CANCELLED' }))
    }
  }
}

export function* epochDetailsFlow() {
  while (true) {
    yield put(setEpoch({ type: 'GET_EPOCH_START' }))
    const task = yield fork(resolveEpochDetails)
    const action = yield take(['FETCHING_ERROR'])
    if (action.type === 'STOP_FETCHING') {
      yield cancel(task)
    }
  }
}
